import { render } from "./StockItemEdit.vue?vue&type=template&id=61114aa6&ts=true"
import script from "./StockItemEdit.vue?vue&type=script&lang=ts"
export * from "./StockItemEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__